import React from 'react';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { exists } from 'lib/types';
import { push } from 'connected-react-router';
import AuthActions, {
  selectActiveOrganization,
  selectAvailableOrganizations,
  selectIsPublisher,
  selectUser
} from 'redux/auth';
import { OccupationType } from 'lib/enums';
import { ADD_ORGANIZATION_ENTRYPOINT } from 'redux/router';
import {
  processActiveOrganizationChange,
  reloadAppState
} from 'redux/auth/authActions';
import OrganizationSelect from './OrganizationSelect';

export function ActiveOrganizationSelect() {
  const dispatch = useAppDispatch();
  const isPublisher = useAppSelector(selectIsPublisher);

  const user = useAppSelector(selectUser);
  const displayCreateJoinOrganizationTab =
    user?.data().occupation !== OccupationType.publishing.value;

  const availableOrganizations =
    useAppSelector(selectAvailableOrganizations) ?? [];
  const activeOrganization = useAppSelector(selectActiveOrganization);
  const value = exists(activeOrganization) ? activeOrganization : undefined;

  const popoverHeader = isPublisher
    ? 'Switch Publications'
    : 'Switch Organizations';

  /**
   * Enables all organization notices to show
   */
  const onAllOrgsClicked = async () => {
    dispatch(AuthActions.showAllOrgsNotices(true));
    dispatch(reloadAppState());
  };

  const onCreateOrgClicked = () => {
    dispatch(push(ADD_ORGANIZATION_ENTRYPOINT));
  };

  return (
    <OrganizationSelect
      popoverHeader={popoverHeader}
      options={availableOrganizations}
      value={value}
      onChange={newOrg => {
        dispatch(processActiveOrganizationChange(newOrg));
      }}
      showAllOrgsOption
      onAllOrgsClicked={onAllOrgsClicked}
      showCreateOrgOption={displayCreateJoinOrganizationTab}
      onCreateOrgClicked={onCreateOrgClicked}
    />
  );
}
